import { SpinAnimation } from './styles';

interface SpinProps {
  children: React.ReactNode;
}

export const Spin = ({ children }: SpinProps) => <SpinAnimation>{children}</SpinAnimation>;
